import '../../../../Guide/UI/templates/js/home/banners/major_campaign_banner_inline.js';
